<script lang="ts">
  import NotificationBell from '$components/notifications/NotificationBell.svelte';
  import { Dropdown, DropdownDivider, DropdownItem } from 'flowbite-svelte';

  // Configuration flags
  export let loggedIn = false;
  export let balanceTextEnabled = true;

  // Data models
  export let balance = { value: 0 };
  export let user = { first_name: '', last_name: '', email: '' };
  export let profileLinks = { first: { href: '', label: '' }, second: { href: '', label: '' } };

  // Display settings
  export let currencyText = 'kr.';
  export let avatarImage = '';

  // Event callbacks
  export let onClick: (() => void) | undefined = undefined;

  // State flags
  export let isUnread = false;

  export let notificationEnabled = false;
</script>

<div class="profile-avatar {loggedIn ? 'logged-in' : ''}">
  {#if loggedIn}
    <div class="balance-nav">
      {#if balanceTextEnabled}
        Saldo:{/if} <span class="value">{balance?.value?.toFixed(2) ?? 0} {currencyText}</span>
    </div>

    {#if notificationEnabled}
      <div class="desktop-notifications">
        <NotificationBell {isUnread} onClick={() => onClick?.()} width={30} height={30} />
      </div>
    {/if}
    <div class="menu">
      <img src={avatarImage} alt="profile" class="profile" id="avatar" />
      <Dropdown triggeredBy="#avatar">
        <div slot="header" class="info">
          <span class="block name">{user.first_name} {user.last_name}</span>
          <span class="block email">{user.email}</span>
        </div>
        <DropdownDivider />
        <DropdownItem href="/min-konto">Profil</DropdownItem>
        <DropdownDivider />
        <DropdownItem slot="footer">
          <form method="post" action="/?/logout">
            <input class="hover:cursor-pointer" type="submit" value="Log ud" />
          </form>
        </DropdownItem>
      </Dropdown>
    </div>
  {:else}
    <ul class="login">
      <li>
        <a href={profileLinks.first.href}>{profileLinks.first.label} </a>
      </li>
      <li>
        <a href={profileLinks.second.href} class="button login-button">{profileLinks.second.label}</a>
      </li>
    </ul>
  {/if}
</div>
